// extracted by mini-css-extract-plugin
export default {"table":"CIpZ9PRHNlDoI9d6r49sZQ=="};